<template>
    <div
        class="modal fade"
        id="nomenclatureMassEditModal"
        role="dialog"
        aria-labelledby="nomenclatureMassEditModalLabel"
        backdrop="static"
        data-backdrop="static"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5
                        class="modal-title"
                        id="nomenclatureMassEditModalLabel"
                    >{{ $t('registers.nomenclatures.title') }} / {{ $t('buttons.editSelected.btnText') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="loader" v-show="loading"></div>
                    <div v-if="!loading">
                        <div class="form-group">
                            <div class="float-left">
                                <vs-checkbox
                                    v-model="model.editActive"
                                >{{ $t('registers.nomenclatures.editor.editActive') }}</vs-checkbox>
                            </div>
                            <div v-if="model.editActive" class="col-12">
                                <vs-checkbox
                                    v-model="model.active"
                                >{{ $t('registers.nomenclatures.editor.active') }}</vs-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success" @click.stop="onSave">
                        <i class="fas fa-save mr-2"></i>
                        {{$t("buttons.save.btnText")}}
                    </button>
                    <button class="btn btn-danger" @click="hide">
                        <i class="fas fa-ban mr-2"></i>
                        {{$t("buttons.close")}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import nomenclatureService from "../../../services/nomenclature.service";

export default {
    components: {},
    props: {
        value: [Number, Array],
        show: {
            type: Boolean,
            required: false,
        },
        grid: [Object],
    },
    data() {
        return {
            loading: true,
            model: {
                selectedIds: [],
                editActive: false,
                active: false,
            },
        };
    },
    methods: {
        hide() {
            $(this.$el).modal("hide");
        },
        onClose() {
            this.$emit("onClose");
            this.$emit("update:show", false);
        },
        onSave() {
            this.model.selectedIds = [...this.value];
            this.loading = true;

            nomenclatureService
                .massEdit(this.model)
                .then((response) => {
                    this.$vs.notify({
                        title: this.$t("buttons.editSelected.btnText"),
                        text: this.$helpers.responseMessage(response),
                        color: "success",
                        time: this.$store.getters.notificationDuration,
                    });

                    this.$emit("onSave", this.grid);
                    this.$emit("update:show", false);
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t("buttons.editSelected.btnText"),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => (this.loading = false));
        },
    },
    mounted() {
        this.loading = false;

        // add modal close listener
        $(this.$el).on("hidden.bs.modal", this.onClose);
    },
    beforeDestroy() {
        // remove listeners
        $(this.$el).off("hidden.bs.modal");
    },
    watch: {
        show: function (val) {
            if (val) {
                this.model.selectedIds = [];
                this.model.editActive = false;
                this.model.active = false;
            }

            $(this.$el).modal(val ? "show" : "hide");
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
